import React, { Component } from 'react';
import { TextField } from '@mui/material';

class DialogPercentField extends Component {
    validator = (value) => {
        if (value > 100 || value < 0) {
            // if (value > 100) {
            //     this.setState({ error: 'Percent must be less than 100' });
            // }
            // if (value < 0) {
            //     this.setState({ error: 'Percent must be greater than 0' });
            // }
            return;
        }
        this.setState({ error: null });
        this.props.onChange(this.props.field.id, value);
    };

    render() {
        return (
            <TextField
                // error={!!this.state.error}
                // helperText={this.state.error}
                label="Percent"
                variant="outlined"
                margin="dense"
                fullWidth
                value={this.props.value}
                onChange={(event) => this.validator(event.target.value)}
                InputProps={{
                    endAdornment: '%'
                }}
            />
        );
    }
}

export default DialogPercentField;
